import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import {AuthService} from "../../../../shared/services/auth.service";
import { GameMessageType, GameModalMessage } from '../../../../shared/constants/divisional.interface';
import { GameService } from '../../../../shared/services/game/game.service';
import { ActivatedRoute } from '@angular/router';
import { properties } from '../../../../../environments/properties';

@Component({
    selector: 'app-game-summary',
    templateUrl: './game-summary.component.html'
})
export class GameSummaryComponent implements OnInit, OnDestroy  {
    public desktopLogo: string;
    public mobileLogo: string;
    public anonymousHeadline: string;
    public authenticatedHeadline: string;
    public disablePersonalizedDisplay: boolean = false;
    public footer: string;
    public surveyLink: string;
    public xfParentPath: string;
    public xfParentPathPersonalized: string;
    public gameListEmptyMessage: string;
    public programName: string = '';
    public showSummary = false;
    public showListEmpty = false;
    public headline: string = '';
    public personalizedXFContent: string = '';
    public summaryXFContent: string = '';
    @Input() userInfo: any;
    @Input() programId: string;
    
    constructor(public elementRef: ElementRef, private route: ActivatedRoute, public authService :AuthService, public gameService: GameService, private http: HttpClient) {
        this.desktopLogo = properties.summaryPageConfig.desktopLogo;
        this.mobileLogo = properties.summaryPageConfig.mobileLogo;
        this.anonymousHeadline = properties.summaryPageConfig.anonymousHeadline;
        this.authenticatedHeadline = properties.summaryPageConfig.authenticatedHeadline;
        this.disablePersonalizedDisplay = properties.summaryPageConfig.disablePersonalizedDisplay;
        this.footer = properties.summaryPageConfig.footer;
        this.surveyLink = properties.summaryPageConfig.surveyLink;
        this.xfParentPath = properties.summaryPageConfig.xfParentPath;
        this.xfParentPathPersonalized = properties.summaryPageConfig.xfParentPathPersonalized;
        this.gameListEmptyMessage = properties.summaryPageConfig.gameListEmptyMessage;
    }

    ngOnInit(): void {
        this.programName = localStorage.getItem("episodic_game_name");
        this.getPostGameDetails();
        
    }

    public loadAnonymousSummary() {
        this.headline = this.anonymousHeadline;
        this.getExperienceFragmentById(this.xfParentPath, this.programId).subscribe(content => {
            if (content && content != '') {
                this.summaryXFContent = content;
                this.showSummary = true;
            } else {
                this.showListEmpty = true;
            }
        }, error => {
            this.showListEmpty = true;
        });
    }

    public getExperienceFragmentById(xfParentPath: string, programId: string): Observable<string> {

        const url = this.gameService.getApplicationDomainURL() + xfParentPath + '/' + programId + '.content.html';
        return this.http.get(url, { responseType: 'text' }).pipe(
            map(content => content.toString())
        );
    }

    public getPostGameDetails() {
        if (this.gameService.isAuthenticated(this.userInfo) && !this.disablePersonalizedDisplay) {
            this.headline = this.authenticatedHeadline;
            // before calling this fetch the attributes from the personalized game summary api
            this.getExperienceFragmentById(this.xfParentPathPersonalized, this.programId).subscribe(content => {
                if (content && content != '') {
                    // get personalized data
                    this.gameService.getPostGameDetails(this.programId, this.userInfo).subscribe(data => {
                            // replace attributes from API call here, but only if data is not "sad"
                        if (data.gamePlays >= 10) {
                            content = content.replace(/{gamePlays}/g, data.gamePlays);
                            content = content.replace(/{landsCompleted}/g, data.landsCompleted);
                            content = content.replace(/{prizesWon}/g, data.prizesWon);
                            content = content.replace(/{recipesFavorited}/g, data.recipesFavorited);
                            content = content.replace(/{sweepstakesEarned}/g, data.sweepstakesEarned);
                            console.error(content, 'Conter')
                            
                            
                            this.personalizedXFContent = content;
                            this.showSummary = true;
                            
                        } else {
                            this.loadAnonymousSummary();
                        }
                    }, error => {
                        this.loadAnonymousSummary();
                    })
                    
                } else {
                    this.loadAnonymousSummary();
                }
            }, error => {
                this.loadAnonymousSummary();
            })

        } else {
            this.loadAnonymousSummary();
        }
          
    }

    ngOnDestroy() {
        localStorage.removeItem("episodic_game_name")
    }
}
